import React from "react"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {H3, H5} from "@irati/ui/src/Typography"

import {SETTINGS_CUSTOMISE_BENEFITS_SETTINGS} from "../../../routes/routeConfig"
import {PageHeader, TitleAndCount} from "./styled"

interface Props extends InjectIntl {
  minimalView: boolean
  onAdd: () => any
  total: number
}

const HasBenefitsHeader: React.FC<Props> = (props) => {
  const {onAdd, minimalView, total, formatMessage} = props

  return (
    <PageHeader>
      <Flex direction={minimalView ? "row-reverse" : "row"} justifyContent="space-between" margin="0 15px 0" alignItems="center">
        {!minimalView && (
          <TitleAndCount
            title={formatMessage({id: "admin.components.companyBenefitsList.styledNameCountAndButton.title"})}
            count={formatMessage({id: "admin.components.companyBenefitsList.styledNameCountAndButton.count"}, {total})}
          />
        )}
        <Flex>
          <ButtonRouterLink marginRight={1} primary id="settingsBenefitsSettingsId" to={SETTINGS_CUSTOMISE_BENEFITS_SETTINGS}>
            <FormattedMessage id="admin.companyBenefits.button.settings" />
          </ButtonRouterLink>
          <Button id="settingsBenefitsAddBenefit_button" primary onClick={onAdd}>
            <FormattedMessage id="admin.components.companyBenefitsList.styledNameCountAndButton.buttonText" />
          </Button>
        </Flex>

        {minimalView && (
          <H3>
            <FormattedMessage id="admin.components.companyBenefitsList.minimalView.title" />
          </H3>
        )}
      </Flex>
      <Flex marginLeft={2}>
        <H5 marginTop={!minimalView ? 1 : 3}>
          <FormattedMessage id="admin.components.companyBenefits.settings.value" />
        </H5>
      </Flex>
    </PageHeader>
  )
}

export default injectIntl(HasBenefitsHeader)
